export default {
    user: {
        create: {
            title: "Novo usuário",
            model: {
                email: {
                    label: "E-mail",
                    placeholder: "Preencher e-mail"
                },
                name: {
                    label: "Nome",
                    placeholder: "Preencha o nome"
                },
                country: {
                    label: "País",
                    placeholder: "Preencha o país"
                },
                approval_manager_email: {
                    label: "E-mail do gerente",
                    placeholder: "Preencher e-mail do gerente",
                    errors: {
                        different: "O e-mail do gerente de aprovação deve ser diferente do e-mail do usuário"
                    }
                }
            },
            cta: {
                submit: {
                    text: "Enviar",
                    processing: "Enviando"
                },
                cancel: {
                    text: "Cancelar"
                }
            }
        },
        country: {
            title: "País do usuário",
            header: "{email} não possui um país selecionado. Selecione o país dele.",
            model: {
                country: {
                    label: "País",
                    placeholder: "Preencha o país"
                }
            },
            cta: {
                submit: {
                    text: "Enviar",
                    processing: "Enviando"
                },
                cancel: {
                    text: "Cancelar"
                }
            }
        }
    }
}